import { useAuthBaseURL } from "./useAuthBaseURL";

interface UseAuthxNavUrlsResult {
  navSignInHref: string;
  navRegisterHref: string;
}

export function useAuthxNavUrls(): UseAuthxNavUrlsResult {
  const authBaseUrl = useAuthBaseURL();
  const signInBaseUrl = new URL("login", authBaseUrl).toString();
  const registerBaseUrl = new URL("register", authBaseUrl).toString();

  return {
    navSignInHref: signInBaseUrl,
    navRegisterHref: registerBaseUrl,
  };
}
